export default __webpack_public_path__ + "static/media/image1.3b087fb2.jpeg";